import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createValet, getZoneList } from "services/redux/Valet/InfraZone/action";
import InfraZone from "./Zone";

const mapStateToProps = (state) => ({
    infraZoneRes : state.CreateInfraZoneReducer.infraZoneRes,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        createValet,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InfraZone);